import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
export const ContentWrapper = styled.div `
  width: 100%;
  padding: 0 1.5rem 1.5rem;
`;
export const CoinsInfoContainer = styled(ContentLoader) `
  width: 100%;
  background-color: ${({ theme }) => theme.colors.surface.default};
  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.high};
  height: 14rem;
`;
export const BaseIconWrapper = styled.rect `
  rx: ${({ theme }) => theme.borderRadius.mediumHigh};
  height: 12.5rem;
  width: 5.5rem;
  y: 0.8rem;
  x: 0.8rem;
  ${({ theme }) => theme.media.tablet `
    x: 1.5rem;
    y: 1.5rem;
    height: 10rem;
    width: 15rem;
  `};
`;
export const QuoteAssetIcon = styled.rect `
  rx: ${({ theme }) => theme.borderRadius.mediumHigh};
  height: 5rem;
  width: 7rem;
  y: 0.8rem;
  x: 7rem;
  ${({ theme }) => theme.media.tabletS `
    x: 10rem;
    width: 10rem;
  `};
  ${({ theme }) => theme.media.tablet `
    y: 1.5rem;
    x: 22rem;
    height: 4rem;
    width: 10rem;
  `};
`;
export const QuoteAssetBottom = styled.rect `
  rx: ${({ theme }) => theme.borderRadius.mediumHigh};
  height: 5rem;
  width: 7rem;
  y: 7rem;
  x: 7rem;
  ${({ theme }) => theme.media.tabletS `
    x: 10rem;
    width: 10rem;
  `};
  ${({ theme }) => theme.media.tablet `
    x: 22rem;
    y: 7rem;
    height: 4rem;
    width: 10rem;
  `};
`;
const Fee = styled.rect `
  rx: ${({ theme }) => theme.borderRadius.mediumHigh};
  height: 3rem;
  width: 5rem;
  ${({ theme }) => theme.media.tablet `
    width: 7rem;
  `};
`;
export const BuyFeeTop = styled(Fee) `
  y: 0.8rem;
  x: 15rem;
  ${({ theme }) => theme.media.tabletS `
    x: 45%;
  `};
  ${({ theme }) => theme.media.tabletL `
    x: 40rem;
    y: 1.5rem;
  `};
`;
export const BuyFeeBot = styled(Fee) `
  y: 7rem;
  x: 15rem;
  ${({ theme }) => theme.media.tabletS `
    x: 45%;
  `};
  ${({ theme }) => theme.media.tabletL `
    x: 40rem;
  `};
`;
export const SellFeeTop = styled(Fee) `
  y: 0.8rem;
  x: 22rem;
  ${({ theme }) => theme.media.tabletS `
    x: 60%;
  `};
  ${({ theme }) => theme.media.tablet `
     x: 42rem;
  `};
  ${({ theme }) => theme.media.tabletL `
    y: 1.5rem;
    x: 56rem;
  `};
`;
export const SellFeeBot = styled(Fee) `
  y: 7rem;
  x: 22rem;
  ${({ theme }) => theme.media.tabletS `
    x: 60%;
  `};
  ${({ theme }) => theme.media.tablet `
     x: 42rem;
  `};
  ${({ theme }) => theme.media.tabletL `
    x: 56rem;
  `};
`;
export const AmountTop = styled.rect `
  y: 0.8rem;
  rx: ${({ theme }) => theme.borderRadius.mediumHigh};
  height: 3rem;
  width: 4rem;
  x: calc(100% - 5rem);
  ${({ theme }) => theme.media.mobileL `
    x: calc(100% - 12.5rem);
    width: 8rem;
  `};
  ${({ theme }) => theme.media.tabletL `
    y: 1.5rem;
  `};
`;
export const AmountBot = styled(AmountTop) `
  y: 7rem;
`;
//# sourceMappingURL=styles.js.map